import { IRestResult, IRestResultCreate, IRestResultEdit, IRestForms } from '@/types'
import axios from 'axios'

class CampaignRest {
  async get (id: number, token?: string|null): Promise<IRestResult> {
    return (await axios.get(`/api/campaigns/${id}`, {
      headers: token ? {
        Authorization: token
      } : {}
    })).data
  }

  async edit (token: string | null, id: number, data: IRestResultEdit): Promise<IRestResult> {
    return (await axios.patch(`/api/campaigns/${id}`, data, token ? {
      headers: {
        Authorization: token
      }
    } : {})).data
  }

  async create (token: string | null, data: IRestResultCreate): Promise<IRestResult> {
    return (await axios.post('/api/campaigns', data, token ? {
      headers: {
        Authorization: token
      }
    } : {})).data
  }

  async convertForm (token: string|null, data: {
    target_type: 'newsletter' | 'competition' | 'combined' | 'competition-newsletter',
    forms: IRestForms,
    locales: string[]
  }): Promise<IRestForms> {
    const resp = await axios.post('/api/campaigns/forms/convert', data, {
      headers: {
        Authorization: token
      }
    })
    return resp.data
  }
}

export default new CampaignRest()
